export function fmtMoney(v, currency = "FCFA") {
  const n = Math.round(Number(v) || 0);
  return n.toLocaleString("fr-FR").replace(/[\u202f\u00a0]/g, " ") + " " + currency;
}

export function fmtNum(v) {
  return (Number(v) || 0).toLocaleString("fr-FR").replace(/[\u202f\u00a0]/g, " ");
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso.slice(0, 10);
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso.slice(0, 16);
  }
}

export const MOVEMENT_TYPES = {
  initial: "Stock initial", entry: "Entrée", exit: "Sortie", sale: "Vente", sale_cancel: "Annulation vente",
  return_customer: "Retour client", return_supplier: "Retour fournisseur", damage: "Casse",
  loss: "Perte", adjustment: "Ajustement", transfer_out: "Transfert sortant", transfer_in: "Transfert entrant",
  purchase_receipt: "Réception achat", inventory_adjustment: "Ajustement inventaire",
};

export const PAYMENT_METHODS = ["Espèces", "Mobile Money", "Orange Money", "Moov Money", "Wave", "Banque", "Chèque"];

export const STATUS_BADGES = {
  paid: { label: "Payée", cls: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300" },
  partial: { label: "Partielle", cls: "bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300" },
  credit: { label: "Crédit", cls: "bg-rose-100 text-rose-800 dark:bg-rose-950 dark:text-rose-300" },
  unpaid: { label: "Impayée", cls: "bg-rose-100 text-rose-800 dark:bg-rose-950 dark:text-rose-300" },
  ordered: { label: "Commandé", cls: "bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-300" },
  received: { label: "Réceptionné", cls: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300" },
  cancelled: { label: "Annulée", cls: "bg-slate-200 text-slate-600 dark:bg-slate-800 dark:text-slate-400" },
  draft: { label: "Brouillon", cls: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300" },
  converted: { label: "Converti", cls: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300" },
};

export function Badge({ status }) {
  const b = STATUS_BADGES[status] || { label: status, cls: "bg-secondary text-secondary-foreground" };
  return <span data-testid={`badge-${status}`} className={`px-2 py-0.5 rounded-full text-xs font-semibold ${b.cls}`}>{b.label}</span>;
}
